var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileVerify(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.081 2a4.494 4.494 0 1 0 0 8.989 4.494 4.494 0 0 0 0-8.989zM10.528 13.184c.253-.367.01-.927-.435-.927H8.896a6.688 6.688 0 0 0-6.688 6.688 2.73 2.73 0 0 0 2.73 2.73h5.22c.452 0 .694-.574.432-.941a6.555 6.555 0 0 1-1.22-3.82c0-1.384.428-2.67 1.158-3.73z",
    fill: "#999",
    opacity: 1,
    "data-original": "#999",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.04 16.915a5.085 5.085 0 1 1-10.17 0 5.085 5.085 0 0 1 10.17 0zm-2.174-1.933a.75.75 0 0 1 .07 1.059l-2.57 2.933a1.25 1.25 0 0 1-1.829.054l-1.443-1.46a.75.75 0 1 1 1.068-1.055l.876.888a.5.5 0 0 0 .732-.022l2.037-2.326a.75.75 0 0 1 1.059-.07z",
    clipRule: "evenodd",
    fill: "#999",
    opacity: 1,
    "data-original": "#999",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileVerify);
export default __webpack_public_path__ + "static/media/ProfileVerify.d6bea98b0250d7daa02bd0e4c9ee50a5.svg";
export { ForwardRef as ReactComponent };